
import Vue from 'vue';

interface Methods {
  confirmAdult: () => void;
}

interface Props {
  isFullTemplate: boolean;
}

interface Computed {
  classModifier: Record<string, unknown>;
}

export default Vue.extend<unknown, Methods, Computed, Props>({
  props: {
    isFullTemplate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classModifier() {
      return { 'C-article-adult-layer__container--full-template': this.isFullTemplate };
    },
  },
  methods: {
    confirmAdult() {
      this.$store.commit('analytics/setClickEvent', { googleAnalytics: { eventName: 'ANALYTICS_CONFIRM_ADULT', eventData: { type: 'confirm' } } });
      this.$emit('confirm-adult');
    },
  },
});
